import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      d="M6 2C3.79086 2 2 3.79086 2 6V18C2 20.2091 3.79086 22 6 22H18C20.2091 22 22 20.2091 22 18V6C22 3.79086 20.2091 2 18 2H6ZM11 7.25C11 6.55964 11.5596 6 12.25 6C12.9404 6 13.5 6.55964 13.5 7.25V12.25C13.5 12.9404 12.9404 13.5 12.25 13.5C11.5596 13.5 11 12.9404 11 12.25V7.25ZM13.5 16.4167C13.5 17.107 12.9404 17.6667 12.25 17.6667C11.5596 17.6667 11 17.107 11 16.4167C11 15.7263 11.5596 15.1667 12.25 15.1667C12.9404 15.1667 13.5 15.7263 13.5 16.4167Z"
      fill={fill}
      fillRule="evenodd"
    />
  </g>
);

export default Icon;
